import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import HeroSection from "@/pages/home/components/HeroSection";
import HowItWorks from "@/pages/home/components/HowItWorks";
import FeaturesSection from "@/pages/home/components/FeaturesSection";
import QrTypesSection from "@/pages/home/components/QrTypesSection";
import CtaSection from "@/pages/home/components/CtaSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <HowItWorks />
      <FeaturesSection />
      <QrTypesSection />
      <CtaSection />
      {/* QR Redirect Test Link — preview'da /r route'unu test etmek için */}
      <div className="max-w-5xl mx-auto px-6 pb-8">
        <div className="bg-emerald-50 border border-emerald-100 rounded-xl p-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center flex-shrink-0">
              <i className="ri-qr-scan-2-line text-emerald-600 text-lg"></i>
            </div>
            <div>
              <p className="text-sm font-semibold text-emerald-900">QR Yönlendirme Testi</p>
              <p className="text-xs text-emerald-600">Preview'da /r route'unu test etmek için aşağıdaki linki kullan.</p>
            </div>
          </div>
          <Link
            to="/r?code=ghhSc8"
            className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-external-link-line"></i>
            Test Et: /r?code=ghhSc8
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
}
